/* import __COLOCATED_TEMPLATE__ from './conversation-sla-paused.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationSlaPaused from 'embercom/objects/inbox/renderable/conversation-sla-paused';
import LinkWithText from 'embercom/helpers/link-with-text';
import { createSafeAdminLink } from 'embercom/utils/admin-link';
import {
  truncateEventText,
  isEventTextTruncated,
  FEATURE_FLAG_NAME,
} from 'embercom/lib/inbox2/event-text-truncation';

interface ConversationSlaPausedPart extends RenderablePart {
  renderableData: ConversationSlaPaused;
}

interface Args {
  part: ConversationSlaPausedPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsConversationSlaPausedComponent extends Component<Signature> {
  @service declare session: Session;

  // @ts-ignore helper doesn't seem to be typed correctly
  linkWithTextHelper = LinkWithText.create(this);

  get isConversationEventsUiImprovementsEnabled(): boolean {
    return this.session.workspace?.isFeatureEnabled(FEATURE_FLAG_NAME) ?? false;
  }

  get renderableData() {
    return this.args.part.renderableData;
  }

  get teammate() {
    return this.renderableData.adminSummary;
  }

  get slaLabel(): string {
    return this.renderableData.conversationSla.label;
  }

  get isSlaLabelTruncated(): boolean {
    return this.isConversationEventsUiImprovementsEnabled && isEventTextTruncated(this.slaLabel);
  }

  get displaySlaLabel(): string {
    if (this.isConversationEventsUiImprovementsEnabled) {
      return truncateEventText(this.slaLabel);
    }
    return this.slaLabel;
  }

  get translationKey() {
    if (this.teammate.id === this.session.teammate.id) {
      return this.isConversationEventsUiImprovementsEnabled
        ? 'inbox.conversation-sla-paused.you-paused-sla-v2'
        : 'inbox.conversation-sla-paused.you-paused-sla';
    } else {
      return this.isConversationEventsUiImprovementsEnabled
        ? 'inbox.conversation-sla-paused.admin-paused-sla-v2'
        : 'inbox.conversation-sla-paused.admin-paused-sla';
    }
  }

  get translationData() {
    if (this.teammate.id === this.session.teammate.id) {
      return {
        sla: this.displaySlaLabel,
      };
    } else {
      return {
        who: createSafeAdminLink(this.teammate, this.linkWithTextHelper),
        sla: this.displaySlaLabel,
      };
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationSlaPaused': typeof Inbox2ConversationStreamEventPartsConversationSlaPausedComponent;
    'inbox2/conversation-stream/event-parts/conversation-sla-paused': typeof Inbox2ConversationStreamEventPartsConversationSlaPausedComponent;
  }
}
